import React, { useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

// import { useHandleGenerator } from './RoutesContext';

import * as AppPropTypes from '../lib/PropTypes';

const MenusContext = React.createContext(null);

export const useMenus = () => useContext(MenusContext);

export const useMenu = (id, user) => {
    const { pathname } = useLocation();
    // const handle = useHandleGenerator();
    const { menus } = useMenus();
    const items = menus[id] || [];

    const menu = useMemo(() => {
        let currentItems = items;
        if (id === 'main') {
            if (user) {
                currentItems = menus.withUser.concat(currentItems);
            } else {
                currentItems = menus.withoutUser.concat(currentItems);
            }
        }
        return currentItems.map((it) => ({
            ...it,
            active: it.url === pathname,
        }));
    }, [id, items, menus, user, pathname]);
    return menu;
};

export const useMenuOpen = () => {
    const { menuOpen } = useMenus();
    return menuOpen;
};

export const useToggleMenu = () => {
    const { menuOpen, setMenuOpen } = useMenus();
    return useCallback(() => setMenuOpen(!menuOpen), [menuOpen, setMenuOpen]);
};

export const useCloseMenu = () => {
    const { setMenuOpen } = useMenus();
    return useCallback(() => setMenuOpen(false), [setMenuOpen]);
};

const propTypes = {
    menus: PropTypes.objectOf(AppPropTypes.menuItems).isRequired,
    children: PropTypes.node.isRequired,
    menuOpen: PropTypes.bool,
};

const defaultProps = {
    menuOpen: false,
};

export const MenusProvider = ({ menus, menuOpen: initialMenuOpen, children }) => {
    const [menuOpen, setMenuOpen] = useState(initialMenuOpen);
    return (
        <MenusContext.Provider value={{ menus, menuOpen, setMenuOpen }}>
            {children}
        </MenusContext.Provider>
    );
};

MenusProvider.propTypes = propTypes;
MenusProvider.defaultProps = defaultProps;

export default MenusContext;
